import React from "react";
import { RouterProvider } from "react-router-dom";

import { router } from "./routes";
import { QueryProvider } from "./shared/providers/QueryProvider";
import { ThemeProvider, MasterDataProvider, FilterContextProvider, CapabilitiesProvider } from "./shared/context";

import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css';

const App: React.FC = () => (
  <QueryProvider>
    <ThemeProvider>
      <MasterDataProvider>
        <CapabilitiesProvider>
          <FilterContextProvider>
            <RouterProvider router={router} />
          </FilterContextProvider>
        </CapabilitiesProvider>
      </MasterDataProvider>
    </ThemeProvider>
  </QueryProvider>
);

export default App;